<template>
  <div>
    <div class="d-none" v-html="stringHtml"></div>
    <b-modal
      ref="session-box"
      :size="modalSize"
      :title="modalTitle"
      centered
      modal-class="open-session"
      :no-close-on-esc="isRequired"
      no-close-on-backdrop
      :hide-header-close="isRequired"
      hide-footer
      :hide-header="print"
      @hidden="sessionBoxClose"
      style="padding: 0rem 1.5rem"
      scrollable
    >
      <div v-if="print">
        <p class="mb-3 title">
          <img src="../assets/images/success.svg" class="pt-0" alt />&nbsp;
          Session Closed
        </p>
        <p>
          Please submit the printed settlement slip to the store manager for
          verification.
        </p>
        <div class="d-flex mt-4 justify-content-end">
          <b-button class="mr-1" @click="closeSessionBox" id="session-close">
            Close
          </b-button>
          <b-button
            variant="primary"
            class="ml-1"
            @click="printSlip"
            id="print-session-slip"
          >
            <span v-if="$loading == false">Print Slip</span>
            <b-spinner small v-if="$loading == true"></b-spinner>
          </b-button>
        </div>
      </div>
      <b-form
        class="close-currency"
        @submit.prevent="saveSession"
        v-if="!print"
      >
        <b-row>
          <div class="w-100">
            <!-- <b-col md="12" lg="12" v-show="!isHidden"> -->
            <b-col
              md="12"
              lg="12"
              v-if="state.system.settings.settlement.denomination.status == 0"
            >
              <b-form-group id="form-input" class="total-amount my-2 mx-auto">
                <b-form-input
                  id="session-input"
                  type="number"
                  v-model="totalAmount"
                  size="lg"
                  autofocus
                  class="w-100"
                  placeholder="Enter Amount"
                  :disabled="$loading"
                  v-negative-disable
                />
              </b-form-group>
            </b-col>
            <b-col
              md="12"
              lg="12"
              v-if="
                denomination.length > 0 &&
                  state.system.settings.settlement.denomination.status == 1
              "
              class="denomination-content"
            >
              <b-form-group
                id="form-deno"
                class="total-amount my-2 mx-auto"
                :disabled="denomination.length > 0"
              >
                <b-form-input
                  type="number"
                  v-model="totalAmount"
                  size="lg"
                  class="w-100"
                  placeholder="Amount"
                  autocomplete="off"
                  disabled
                  id="sessoin-total-amount"
                  v-negative-disable
                />
              </b-form-group>
              <b-card no-body class="grey-pills-tabs px-4 py-2">
                <b-tabs pills fill card class="pb-0 denomination-content">
                  <b-tab title="Notes" active>
                    <b-card-text class="notes">
                      <!-- <b-row>
                      <b-col class="text-left">
                        <label style="padding-left: 0px;">Currency</label>
                      </b-col>
                      <b-col>
                        <label></label>
                      </b-col>
                      <b-col class="text-right">
                        <label>Total</label>
                      </b-col>
                      </b-row>-->
                      <div
                        v-bind:key="index"
                        v-for="(denom, index) in denominationList"
                      >
                        <b-row class="mb-2" v-if="denom.type == 'notes'">
                          <b-col cols="3">
                            <p
                              class="mt-2 fs-14"
                              v-text="currencySymbol + denom.currency"
                            ></p>
                          </b-col>

                          <b-col
                            cols="4"
                            class="d-flex align-item-center text-center"
                          >
                            <span class="pt-2 p-0">X</span>
                            <minus-plus
                              :currency="parseInt(denom.currency)"
                              :type="denom.type"
                              @postdata="saveDenomination"
                            />
                          </b-col>
                          <b-col class="text-right" cols="5">
                            <p
                              class="pt-2 pb-0 fs-14"
                              :class="[denom.value == '0' ? 'text-muted' : '']"
                              v-text="currencySymbol + denom.value"
                            />
                            <!-- <b-form-input
                            id="input-2"
                            class="text-right"
                            type="number"
                            size="sm"
                            :value="denom.value"
                            readonly
                            ></b-form-input>-->
                          </b-col>
                        </b-row>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Coins" class="coins">
                    <div
                      v-bind:key="index"
                      v-for="(denom, index) in denominationList"
                    >
                      <b-row class="mb-2" v-if="denom.type == 'coins'">
                        <b-col cols="3">
                          <p
                            class="mt-2 fs-14"
                            v-text="currencySymbol + denom.currency"
                          />
                        </b-col>
                        <b-col
                          cols="4"
                          class="d-flex align-item-center text-center"
                        >
                          <span class="pt-2 p-0">X</span>
                          <minus-plus
                            :currency="parseInt(denom.currency)"
                            :type="denom.type"
                            @postdata="saveDenomination"
                          />
                        </b-col>
                        <b-col class="text-right" cols="5">
                          <p
                            class="pt-2 pb-0 fs-14"
                            v-text="currencySymbol + denom.value"
                          />
                          <!-- <b-form-input
                          id="input-2"
                          class="text-right"
                          type="number"
                          size="sm"
                          :value="denom.value"
                          required
                          ></b-form-input>-->
                        </b-col>
                      </b-row>
                    </div>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-col>
          </div>
          <b-col md="12">
            <footer class="mt-4">
              <b-row>
                <!-- <b-col md="6">
                  <div class="custom-check" v-if="state.sessions.session.denomination.length != ''">
                    <input
                      class="pull-right"
                      type="checkbox"
                      id="denomination"
                      v-on:click="isHidden = !isHidden"
                    />
                    <label for="denomination">&nbsp; &nbsp;View Denomination</label>
                  </div>
                </b-col>-->
                <b-col md="12">
                  <b-button
                    type="submit"
                    variant="primary"
                    class="float-right"
                    :disabled="totalAmount == '' || $loading"
                    id="session-cont"
                  >
                    <span v-if="!$loading">Continue</span>
                    <b-spinner small v-if="$loading" />
                  </b-button>
                </b-col>
              </b-row>
            </footer>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>
<style lang="scss" scoped>
.input-fields .disabled {
  background-color: #f0f0f0 !important;
}
</style>

<script>
import axios from "axios";
import { mapState } from "vuex";
import MinusPlus from "../components/MinusPlus";
import qz from "../printer";
export default {
  name: "session-modal-box",
  components: {
    MinusPlus,
  },
  props: {
    open: { default: false, type: Boolean },
  },
  data() {
    return {
      type: "",
      denomination: [],
      modalSize: "sm",
      modalTitle: "",
      totalAmount: "",
      date: new Date(),
      isRequired: false,
      colLength: 12,
      currency: [],
      // isHidden: false,
      print: false,
      stringHtml: "",
    };
  },
  watch: {
    open() {
      var self = this;
      if (this.open) {
        this.$refs["session-box"].show();
        this.settlementData();

        // console.log("[sessionBox] : Open");
      } else {
        this.$refs["session-box"].hide();
        self.denomination = [];
        self.currency = [];
        self.totalAmount = "";
        // console.log("[sessionBox] : Close");
      }
    },
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    currentDate() {
      return this.$moment().format("DD MMMM YYYY h:mm:ss A");
    },
    denominationList() {
      return this.denomination.slice(0).reverse();
    },
    printSize() {
      let size = 80;
      this.state.system.settings.print.map((item) => {
        if (item.name == "bill_print") {
          size = item.width;
        }
      });
      return size;
    },
  },
  methods: {
    closeSessionBox() {
      this.$refs["session-box"].hide();
      this.print = false;
    },
    saveDenomination(data) {
      this.totalAmount = 0;

      let existsCurrency = this.currency.filter((addval) => {
        return (
          addval.currency == data.currency &&
          addval.currency_type.toLowerCase() == data.type
        );
      });
      if (existsCurrency.length == 0) {
        this.currency.push({
          currency_type: data.type.toUpperCase(),
          currency: data.currency,
          qty: data.value / data.currency,
        });
      }

      this.denomination.map((item) => {
        if (
          parseInt(item.currency) == data.currency &&
          item.type == data.type
        ) {
          item.value = data.value;
          if (this.currency.length > 0) {
            this.currency.map((curr) => {
              if (
                curr.currency == data.currency &&
                curr.currency_type.toLowerCase() == data.type
              ) {
                curr.qty = data.value / data.currency;
              }
            });
          } else {
            this.currency.push({
              currency_type: data.type.toUpperCase(),
              currency: data.currency,
              qty: data.value / data.currency,
            });
          }
        }
        this.totalAmount += item.value;
      });
    },
    settlementData() {
      var self = this;
      let session = this.state.sessions.session;
      this.type = session.type;
      if (session.type == "open") {
        self.modalTitle = "Open Session";
      } else {
        self.modalTitle = "Close Session";
      }
      // console.log(session.denomination);
      if (Object.keys(session.denomination).length > 0) {
        this.modalSize = "md";
        this.colLength = 5;
        Object.keys(session.denomination).filter((cyType) => {
          session.denomination[cyType].map((item) =>
            self.denomination.push({ currency: item, type: cyType, value: 0 })
          );
        });
      }

      if (session.required == 1) {
        this.isRequired = true;
        // this.type = 1;
      } else {
        this.isRequired = false;
      }
    },
    sessionBoxClose() {
      // this.isHidden = false;
      this.$emit("close-session", false);
    },
    saveSession() {
      this.$loading = true;
      // console.log(this.type + " Session Event Fire");
      let openingAmt = "";
      let closeAmt = "";
      let url = "";
      let dynamic = "";
      if (this.type == "open") {
        openingAmt = this.totalAmount;
        //     console.log(openingAmt);
        url = "/vendor/opening-balance";
      } else if (this.type == "close") {
        closeAmt = this.totalAmount;
        url = "/vendor/closing-balance";
        dynamic = this.state.system.settings.settlement.settlement_session_id;
        // this.print = true;
      }
      let postData = {
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.id,
        type: "CASH",
        trans_from: this.state.system.trans_from,
        opening_balance: openingAmt,
        closing_balance: closeAmt,
        currency: JSON.stringify(this.currency),
        terminal_id: this.state.system.terminal_id,
        settlement_date: this.$moment(new Date()).format("YYYY-MM-DD"),
        url: url,
        session_type: this.type,
        api_token: this.state.sessions.user.api_token,
        settlement_session_id: dynamic,
      };
      // console.log(postData);
      this.$store
        .dispatch("sessions/saveSession", postData)
        .then((res) => {
          if (res.data.status == "fail") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
            this.$refs["session-box"].hide();
            this.$loading = false;
            return;
          }
          if (this.type == "close") {
            this.print = true;
            this.modalSize = "sm";
          } else {
            this.$refs["session-box"].hide();
          }
          this.$store.commit("sessions/setSessionDetails", res.data.settings);
          this.$loading = false;
        })
        .catch(() => (this.$loading = false));
    },
    printSlip() {
      this.$loading = true;
      if (typeof Android !== "undefined" && Android !== null) {
        let sessionData = {
          v_id: this.state.sessions.user.vendor_id,
          store_id: this.state.sessions.user.store_id,
          vu_id: this.state.sessions.user.vu_id,
          settlement_session_id: this.state.system.settings.settlement
            .settlement_session_id,
          trans_from: this.state.system.trans_from,
          api_token: this.state.sessions.user.api_token,
          manufacturer_name: this.state.settings.device_name,
          url: "vendor/print-settlement",
        };
        // let data = Object.assign(invoiceData, this.customerData);
        axios
          .post(sessionData.url, sessionData)
          .then((res) => {
            this.$loading = false;
            // console.log(res.data.print_data);
            if (res.data.status == "fail") {
              let alertData = {
                message: res.data.message,
                type: "danger",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
              this.$refs["session-box"].hide();
            } else {
              let postData = {
                type: "print_settlement",
                data: res.data.print_data,
              };
              returnValue(postData);
            }
            this.$refs["session-box"].hide();
            this.print = false;
          })
          .catch(() => (this.$loading = false));
      } else {
        let manuName = "";
        if (this.state.system.printer != "") {
          manuName = this.state.system.printer;
        }
        let postData = {
          v_id: this.state.sessions.user.vendor_id,
          store_id: this.state.sessions.user.store_id,
          vu_id: this.state.sessions.user.vu_id,
          settlement_session_id: this.state.system.settings.settlement
            .settlement_session_id,
          trans_from: this.state.system.trans_from,
          manufacturer_name: manuName,
          terminal_id: this.state.system.settings.terminal_id,
          api_token: this.state.sessions.user.api_token,
          url: "vendor/print-settlement",
        };
        axios
          .post(postData.url, postData)
          .then((res) => {
            this.$loading = false;
            if (res.data.status == "fail") {
              let alertData = {
                message: res.data.message,
                type: "danger",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
              this.$refs["session-box"].hide();
            } else {
              if (this.state.system.printer != "" && qz.websocket.isActive()) {
                this.stringHtml = res.data.print_data
                  .replace(
                    /<size=24>|<bold>|<\/bold>|<\/size>|<normal>|<\/normal>/gi,
                    ""
                  )
                  .replace(/<center>/gi, "<div class='cool-center'>")
                  .replace(/<left>/gi, "<div class='cool-left'>")
                  .replace(/<right>/gi, "<div class='cool-right'>")
                  .replace(/<text>/gi, "<span>")
                  .replace(/<\/text>/gi, "</span>")
                  .replace(/<\/center>|<\/left>|<\/right>/gi, "</div>");
                this.stringHtml =
                  "<div class='webpos-print'>" + this.stringHtml + "</div>";
                setTimeout(() => {
                  this.printHtml();
                }, 1000);
                // this.printHtml(res.data.print_data);
                this.$refs["session-box"].hide();
              } else {
                this.$store.commit(
                  "sessions/saveLastSessionPrintData",
                  res.data.html_data
                );
                this.$refs["session-box"].hide();
              }
            }
            this.$loading = false;
            this.print = false;
          })
          .catch(() => (this.$loading = false));
      }
    },
    printHtml() {
      let billData = [];
      let data = document.querySelectorAll(".webpos-print");
      // console.log(data);
      for (var i = 0; i < data.length; i++) {
        let tempData = data[i].childNodes;
        for (var j = 0; j < tempData.length; j++) {
          billData.push({
            content: tempData[j].textContent,
            size: tempData[j].textContent.length,
          });
        }
      }
      let htmlData = "";
      htmlData = Object.keys(billData)
        .map(function(k) {
          let convert = "";
          if (billData[k].size == 1) {
            convert = billData[k].content;
            convert = convert.toString();
          } else {
            convert = billData[k].content.substr(
              0,
              billData[k].content.length - 1
            );
            convert = convert + "\x0A";
            convert = convert.toString();
          }
          return convert;
        })
        .join("");
      // console.log(htmlData.toString());

      let config = qz.configs.create(this.state.system.printer, {
        units: "mm",
      });
      let centerAlign = "\x1B" + "\x61" + "\x31";
      let paperCut = "\x1D" + "\x56" + "\x30";
      let lineBreak = "\x0A" + "\x0A" + "\x0A";
      let pdata = [centerAlign + htmlData + lineBreak + paperCut];
      qz.print(config, pdata);
      // console.log(pdata);
      // let self = this;
      // let printerConfig = {
      //   colorType: "blackwhite",
      //   copies: 1,
      //   margins: "0",
      //   rasterize: "false",
      //   rotation: "0",
      //   scaleContent: "false",
      //   units: "mm"
      // };
      // let config = qz.configs.create(this.state.system.printer, printerConfig);
      // let options = {
      //   language: "ESCP"
      // };
      // let size = 11;
      // // Paper width 8 cm
      // let defaultStyle =
      //   "<style>* { font-size: 10px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table {width:280px;  margin-left: -70px; margin-right:0px;  } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; margin-left:-10px } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:0px !important; } tbody { display: table !important; }</style>";
      // if (this.printSize == 58) {
      //   // Paper width 5 cm
      //   size = 10;
      //   defaultStyle =
      //     "<style>* { font-size: 8px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table { width:200px;  margin-left:-80px; margin-right:5px } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:15px !important; } tbody { display: table !important; width: inherit; word-wrap: break-word; }</style>";
      // }
      // let data = [
      //   {
      //     type: "raw",
      //     format: "html",
      //     flavor: "plain", // or 'plain' if the data is raw HTML
      //     // data: this.state.billing.invoice.data.html_data,
      //     data: "<html><body>" + defaultStyle + html + "</body></html>"
      //     // data:
      //     //   '<html><body><style>* { font-size: 10px; white-space: pre-wrap; }</style><table style="border:1px solid black"><tr><td style="font-size:13px"><b><pre>Pos Store -1\n</pre></b></td></tr><tr><t d style="font-size:12px"><span><pre>D-3 Phase-II Opp Lajpat Nagar Police Station Cool School\n</pre></span></t></tr></table></body></html>'
      //   }
      // ];
      // // console.log(config);
      // qz.print(config, data)
      //   .then(function() {
      //     console.log("Sent data to printer");
      //   })
      //   .catch(function(e) {
      //     console.error(e);
      //   });
    },
  },
};
</script>
<style lang="scss" scoped>
@keyframes hide {
  0% {
    display: none;
    opacity: 0;
  }
  100% {
    display: block;
    opacity: 1;
  }
}
.denomination-content {
  animation: hide 1s linear;
  animation-fill-mode: forwards;
}
.coins span {
  color: #fff;
}
.theme-light .coins span {
  color: #808080;
}
/* .total-amount .form-control:disabled,
.form-control {
  background: transparent;
  border: 1px #c0c0c0 solid !important;
} */
.theme-light .grey-pills-tabs h6,
.theme-light .grey-pills-tabs p {
  color: #808080;
  font-weight: 300;
}
// .theme-light .grey-pills-tabs porderspan {
//   color: #808080;
// }
.denomination {
  float: left;
  margin-top: -10px;
}

.custom-check {
  padding-top: 10px;
}
.close-currency .form-control:read-only {
  background-color: transparent !important;

  color: #808080;
}
.theme-light .close-currency .form-control:read-only {
  background-color: transparent !important;
  border: 1px #c0c0c0 solid !important;
  color: #808080;
}
.coins footer .custom-check .btn-success {
  color: #fff;
}

/*.tab-pane {
  max-height: 0;
  overflow: hidden;
  transition: max-height 2000ms ease-in-out;
}

.tab-pane.active {
  max-height: 999em;
}*/
</style>
